import React from 'react';
import { Link } from 'react-router-dom';
import { blogPath, tagPath, formatDate } from '../../utils/blog';
import './style.scss';

// Blog post card shared by the blog index, tag pages and the home page.
// `featured` renders a wide, side-by-side card for the latest post.
const PostCard = ({ post, featured = false, headingLevel = 'h3' }) => {
    const Heading = headingLevel;
    const tag = (post.tags || [])[0];
    const href = blogPath(post);

    return (
        <article className={`postCard${featured ? ' postCard--featured' : ''}`}>
            <Link to={href} className="postCard__media" tabIndex={-1} aria-hidden="true">
                {post.banner_url && <img src={post.banner_url} alt="" loading={featured ? 'eager' : 'lazy'} decoding="async" width="1200" height="675" />}
            </Link>
            <div className="postCard__body">
                {tag && <Link to={tagPath(tag)} className="postCard__tag">{tag}</Link>}
                <Heading className="postCard__title">
                    <Link to={href}>{post.title}</Link>
                </Heading>
                {post.excerpt && <p className="postCard__excerpt">{post.excerpt}</p>}
                <div className="postCard__meta">
                    <span>{formatDate(post.creation_date)}</span>
                    {post.read_minutes && <span>{post.read_minutes} min read</span>}
                </div>
            </div>
        </article>
    );
};

export default PostCard;
